export default class Header {
    version!: string;
    numSensPnts!: number;
    chunkID!: number;
    constructor() {}
}
